var map = {
	"./IndexReviewCarousel/denisa-gafova.jpg": 51377,
	"./IndexReviewCarousel/jan-svoboda.jpg": 48442,
	"./IndexReviewCarousel/kamila-pilna.jpg": 53918,
	"./IndexReviewCarousel/karel-antos.jpg": 71671,
	"./IndexReviewCarousel/lada-kosova.jpg": 11362,
	"./IndexReviewCarousel/petr-jaros.jpg": 66943,
	"./about/goodcall.jpg": 75746,
	"./baseCounter/blue.jpg": 99915,
	"./baseCounter/brown.jpg": 85067,
	"./baseCounter/orange.jpg": 60225,
	"./baseCounter/pink.jpg": 81307,
	"./instructors/adam-libra.jpg": 47948,
	"./instructors/ondrej-hanus.jpg": 33082,
	"./instructors/petr-jaros.jpg": 60353,
	"./lectures/Bitmap.jpg": 26314,
	"./lectures/lecturesCards/image/goodcall.jpg": 14379,
	"./lectures/pageHeader/header-hd.jpg": 77196,
	"./lectures/pageHeader/header-lg.jpg": 30335,
	"./lectures/pageHeader/header-xxl.jpg": 81574,
	"./lectures/pageHeader/header.jpg": 79661,
	"./microsoft365/microsoft365About/cyber-security.jpg": 54804,
	"./microsoft365/microsoft365About/microsoft-365.jpg": 57575,
	"./microsoft365/microsoft365About/microsoft-azure.jpg": 52334,
	"./microsoft365/microsoft365About/power-automate.jpg": 58096,
	"./microsoft365/microsoft365About/power-bi.jpg": 70585,
	"./microsoft365/microsoft365About/students.jpg": 75326,
	"./microsoft365/microsoft365More/cyber-security.jpg": 90758,
	"./microsoft365/microsoft365More/microsoft-365.jpg": 89221,
	"./microsoft365/microsoft365More/microsoft-azure.jpg": 69652,
	"./microsoft365/microsoft365More/power-automate.jpg": 51210,
	"./microsoft365/microsoft365More/power-bi.jpg": 30491,
	"./microsoft365/pageHeader/header-hd.jpg": 9251,
	"./microsoft365/pageHeader/header-lg.jpg": 88280,
	"./microsoft365/pageHeader/header-xxl.jpg": 6387,
	"./microsoft365/pageHeader/header.jpg": 13924,
	"./popup/bezpecnost2024_1.jpg": 81947,
	"./students/pageHeader/header-hd.jpg": 46463,
	"./students/pageHeader/header-lg.jpg": 9676,
	"./students/pageHeader/header-xxl.jpg": 80551,
	"./students/pageHeader/header.jpg": 37736,
	"./studyProgram/pageHeader/header-hd.jpg": 4892,
	"./studyProgram/pageHeader/header-lg.jpg": 97135,
	"./studyProgram/pageHeader/header-xxl.jpg": 74134,
	"./studyProgram/pageHeader/header.jpg": 31805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75760;